import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import NavTitle from "../Components/common/NavTitle";
import { Container, Row, Col, Image } from "react-bootstrap";
import image1 from "../assets/img/DSC02477.jpg";
import image2 from "../assets/img/DSC02478.jpg";
import image3 from "../assets/img/DSC02481.jpg";
import image4 from "../assets/img/DSC02543.jpg";


export default function Actualite() {
  const { id } = useParams();

  return (
    <>
      {/* Titre de la page */}
      <NavTitle title="Graduation Day - First Canadian International School" />

      <Container className="py-5">

        {/* Image principale de l'événement */}
        <Row className="mb-4">
          <Col>
            <Image
              src={image1}
              alt="Graduation Day Main Event"
              className="img-fluid rounded shadow"
            />
          </Col>
        </Row>

        {/* Section des informations à savoir */}
        <Row className="mb-4">
          <Col>
            <h2 className="mb-3">Choses à Savoir</h2>
            <p>
              Le <strong>Graduation Day</strong> est l'un des moments les plus
              mémorables pour nos élèves et leurs familles. Cette journée marque
              la fin d'un chapitre éducatif important et célèbre les
              accomplissements de nos étudiants.
            </p>
          </Col>
        </Row>

        {/* Galerie d'images de la fête */}
        <Row className="mb-4">
          <Col>
            <h2 className="mb-3">Moments Inoubliables</h2>
          </Col>
        </Row>

        <Row>
          <Col md={4} className="mb-3">
            <Image
              src={image2}
              alt="Cérémonie de remise des diplômes"
              className="img-fluid rounded shadow"
            />
            <p className="text-center mt-2">Cérémonie de remise des diplômes</p>
          </Col>
          <Col md={4} className="mb-3">
            <Image
              src={image3}
              alt="Photo de famille"
              className="img-fluid rounded shadow"
            />
            <p className="text-center mt-2">Photo avec les familles</p>
          </Col>
          <Col md={4} className="mb-3">
            <Image
              src={image4}
              alt="Célébration avec les étudiants"
              className="img-fluid rounded shadow"
            />
            <p className="text-center mt-2">Célébration avec les étudiants</p>
          </Col>
        </Row>
      </Container>
    </>
  );
}
